export const apiUrl = import.meta.env.VITE_API_URL;
export const imageUrl = import.meta.env.VITE_IMAGE_URL;
